import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-pipe',
  templateUrl: './one-pipe.component.html',
  styleUrls: ['./one-pipe.component.scss']
})
export class OnePipeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
